type NotificationType = 'success' | 'error' | 'info';

type NotificationListener = (message: string, type: NotificationType) => void;

class NotificationSystem {
    private listeners: NotificationListener[] = [];

    /**
     * Subscribe to notifications
     */
    subscribe(listener: NotificationListener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    /**
     * Notify all listeners
     */
    private emit(message: string, type: NotificationType) {
        this.listeners.forEach(listener => listener(message, type));
    }

    /**
     * Show success notification
     * Only use for user-triggered actions (save, create, login)
     */
    success(message: string) {
        this.emit(message, 'success');
    }

    /**
     * Show error notification
     * Use for API errors and system failures
     */
    error(message: string) {
        this.emit(message, 'error');
    }

    /**
     * Show info notification
     */
    info(message: string) {
        this.emit(message, 'info');
    }
}

export const notify = new NotificationSystem();
